import { prefix } from '@root/utils/Lang';

const modulePrefix = 'module.cms';

const translations = {
    'cms': 'Cikkek',
    'cmsEdit': 'Cikk szerkesztése',
    'cmsCreate': 'Új cikk',
    'edit.title': 'Cikk szerkesztése',
    'id.title': 'ID',
    'title.title': 'Cím',
    'content.title': 'Tartalom',
    'url_key.title': 'URL',
    'url_key.hint': 'Ne használj ékezetes betűket, szóközt és különleges karaktereket!',
    'is_active.title': 'Aktív',
    'active_from.title': 'Aktív -tól',
    'active_to.title': 'Aktív - ig',
    'meta_title.title': 'Meta title',
    'meta_keywords.title': 'Meta keywords',
    'meta_keywords.hint': 'A kulcsszavak között használj vesszőt és szóközt!',
    'meta_description.title': 'Meta description',
    'meta_description.hint': 'Maximum 300 karaktert írj!',
};

export default prefix(modulePrefix, translations);



// WEBPACK FOOTER //
// ./src/modules/Cms/lang/hu.ts